// LICENSE_CODE ZON
'use strict'; /*jslint browser:true, es6:true, node:true, react:true*/
import React, {Fragment} from 'react';
import {capitalize} from 'zstring';
import {use_translation_v} from '../../lib/trans_v';

export const Text_privacy = ({host})=>{
    const email = `privacy@${host}`;
    const domain = capitalize(host);
    const pref = 'legal.privacy.';
    const {t: t_v, T: T_v} = use_translation_v();
    const t = (key, ...rest)=>t_v(`${pref}${key}`, ...rest);
    const T = props=>{
        const {i18nKey, ...rest} = props;
        return <T_v i18nKey={`${pref}${i18nKey}`} {...rest}/>;
    };
    return <Fragment>
      <p><T i18nKey="intro" values={{domain}}/></p>
      <h3><T i18nKey="collect.title"/></h3>
      <p><T i18nKey="collect.p1"/></p>
      <ul>
        <li><T i18nKey="collect.l1"/></li>
        <li><T i18nKey="collect.l2"/></li>
        <li><T i18nKey="collect.l3"/></li>
        <li><T i18nKey="collect.l4"/></li>
      </ul>
      <h3><T i18nKey="use.title"/></h3>
      <p><T i18nKey="use.p1"/></p>
      <h3><T i18nKey="extraordinary.title"/></h3>
      <p><T i18nKey="extraordinary.p1"/></p>
      <p><T i18nKey="extraordinary.p2"/></p>
      <h3><T i18nKey="EEA.title"/></h3>
      <p><T i18nKey="EEA.p1"/></p>
      <h3><T i18nKey="security.title"/></h3>
      <p><T i18nKey="security.p1"/></p>
      <h3 id="delete_rights"><T i18nKey="rights.title"/></h3>
      <p><T i18nKey="rights.p1"/></p>
      <p><T i18nKey="rights.p2"/></p>
      <p><T i18nKey="rights.p3"/></p>
      <p><T i18nKey="rights.p4" values={{email}} components={{a: <a
        href={`mailto:${email}`}/>}}/></p>
      <h3><T i18nKey="retention.title"/></h3>
      <p><T i18nKey="retention.p1"/></p>
      <p><T i18nKey="retention.p2"/></p>
      <p><T i18nKey="retention.p3"/></p>
      <h3><T i18nKey="cookies.title"/></h3>
      <p><T i18nKey="cookies.p1"/></p>
      <p><T i18nKey="cookies.p2" values={'Google Analytics Terms of Use'}
        components={{a: <a
          href='https://marketingplatform.google.com/about/analytics/terms/us/'
        />}}/>
      </p>
      <p><T i18nKey="cookies.p3" values={'Microsoft Privacy Statement'}
        components={{a: <a
          href='https://www.microsoft.com/en-us/privacy/privacystatement'
        />}}/>
      </p>
      <h3><T i18nKey="warranty.title"/></h3>
      <p><T i18nKey="warranty.p1"/></p>
      {t('warranty.p2', '') && <p><T i18nKey="warranty.p2"/></p>}
      <h3><T i18nKey="ownership_change.title"/></h3>
      <p><T i18nKey="ownership_change.p1"/></p>
      <h3><T i18nKey="policy_change.title"/></h3>
      <p><T i18nKey="policy_change.p1"/></p>
      {t('policy_change.p2', '') && <p><T i18nKey="policy_change.p2"/></p>}
      <h3><T i18nKey="contact.title"/></h3>
      <p><T i18nKey="contact.p1" values={{email}} components={{a: <a
        href={`mailto:${email}`}/>}}/></p>
      <p><T i18nKey="contact.p2"/></p>
    </Fragment>;
};
